import styled from 'styled-components';

type ColumnsWrapperProps = {
  gap?: string;
  paddingBottom?: string;
};

export const ColumnsWrapper = styled.div<ColumnsWrapperProps>`
  display: flex;
  gap: ${props => (props.gap ? props.gap : '0px')};
  padding-bottom: ${props =>
    props.paddingBottom ? props.paddingBottom : '0px'};
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: baseline;
  margin-bottom: 24px;
`;
